<template lang="pug">
  div
    span.px-2( v-if='actions.show' )
      router-link.text-dark.table-action( :to="{ name: 'Show ' + entityName, params: { id: id }  }" :title='showTitle()' )
        i.table-action__icon.icon-doc

    span.px-2(v-if='actions.edit')
      router-link.text-primary.table-action( :to="{ name: 'Edit ' + entityName, params: { id: id } }" title='edit' )
        i.table-action__icon.icon-note

    span.px-2(v-if='actions.ban')
      router-link.text-warning.table-action( :to="{ name: 'Home' }" title='ban' )
        i.table-action__icon.icon-ban

    span.px-2(v-if='actions.delete')
      a.text-danger.table-action( v-if='options.deleteable' @click='deleteAlert()' title='delete' )
        i.table-action__icon.icon-trash
      a.table-action.undeleteable( v-else @click='cantDeleteAlert()' title='delete' )
        i.table-action__icon.icon-trash(title='delete')
</template>

<script>
  import Policeman from '@/utils/Policeman/policeman'
  import server from '@/server'
  import RouteGen from '@/utils/apiRoutes'
  import Messages from '@/utils/notificationsMsg'

  export default {
    name: 'TableActions',
    data () {
      return {
        entity: this.$route.meta.entity,
        entityName: '',
        url: this.$route.path,
        actions: {
          show: false,
          edit: false,
          ban: false,
          delete: false
        }
      }
    },
    props: {
      id: {
        type: Number,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    mounted () {
      this.$set(this.$data, 'entityName', this.getEntityName())
      let currentActions = Policeman.permitActions(this.$data.entity)
      this.$set(this.$data, 'actions', currentActions)
    },
    methods: {
      getEntityName () {
        switch (this.$route.meta.entity) {
          case 'structure':
            return 'object'
          case 'checklist':
            return 'inspection'
          default:
            return this.$route.meta.entity
        }
      },
      showTitle () {
        if (this.$data.entityName === 'inspection') { return 'report' }
        return 'show'
      },
      deleteAlert () {
        if (confirm('Do you want to delete this ' + this.entityName + '?')) {
          let url = RouteGen.delete(this.entity, this.id)
          server.delete(url)
          .then(res => {
            this.showNotification(200, 'deleted')
            location.reload()
          })
          .catch(err => {
            this.showNotification(err.response.status)
          })
        }
      },
      cantDeleteAlert () {
        alert('WARNING: This Object cannot be removed because it has already been used in a project')
      },
      showNotification (status) {
        return this.showMessage(Messages.byStatus(status))
      }
    },
    notifications: {
      showMessage: {}
    }
  }
</script>

<style lang="sass">
  .table-action
    cursor: pointer
    position: relative
    &:hover
      text-decoration: none
    &__icon
      font-weight: bold
      font-size: 1.1rem
    &.undeleteable
      opacity: 0.8
      i
        color: #c7cbd5
      &:hover
        i
          color: #ff5454
        &:before
          background-color: #ff5454
      &:before
        content: ''
        position: absolute
        z-index: 1
        left: 50%
        top: 50%
        transform: translate(-50%, -50%) rotate(45deg)
        height: 160%
        width: 2px
        background-color: #c7cbd5


</style>



// WEBPACK FOOTER //
// src/components/Shared/TableActions.vue